import { GLOBALS } from "config/GLOBALS";

export default {
  padding: "8px 0 8px 12px",
  cursor: "pointer",
  width: "80%",
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontFamily: "Muller Thin",
  color: "#fff",
  fontSize: "16px",
  lineHeight: "21px",
  boxSizing: "border-box",
  backgroundColor: GLOBALS.COLORS.PRIMARY_COLOR,
  marginLeft: 28,
  borderRadius: 16,
};
